import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home',
      color: "dark"
    },
    {
      title: 'Search',
      url: '/search',
      icon: 'search',
      color: "medium"

    },
    {
      title: 'Bedside Teaching',
      url: '/bedside-teaching',
      icon: 'md-bed',
      color: "primary"
    },
    {
      title: 'Didactic Teaching',
      url: '/didactic-learning',
      icon: 'md-book',
      color: 'secondary'
    },
    {
      title: 'Clinical Teaching',
      url:'/clinical-teaching',
      icon: 'medkit',
      color: "secondary"
    },
    {
      title: 'Learner Levels',
      url: '/learner-differences',
      icon: 'contacts',
      color: "primary"

    },
    {
      title: 'Feedback',
      url: '/feedback',
      icon: 'chatboxes',
      color: "tertiary"
    },
    {
      title: 'References',
      url: '/references',
      icon: 'md-link',
      color: 'tertiary'},
    {
      title: 'About Us',
      url: '/about-us',
      icon: 'information-circle-outline',
      color: "primary"
    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
}
